import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import MasterDistributorDashboard from '../pages/modules/master_distributor';
import UserManagementRetailer from '../pages/modules/master_distributor/UserManagementRetailer';
import UserManagementDistributor from '../pages/modules/master_distributor/UserManagementDistributor';
import TopUpRequestFromRetailer from '../pages/modules/master_distributor/TopUpRequestFromRetailer';
import SendTopUpRequest from '../pages/modules/master_distributor/SendTopUpRequest';
import ReportsLedger from '../pages/modules/master_distributor/ReportsLedger';
import ReportsCommission from '../pages/modules/master_distributor/ReportsCommission';
import ReportsTopUpHistory from '../pages/modules/master_distributor/ReportsTopUpHistory';
import ReportsOutstanding from '../pages/modules/master_distributor/ReportsOutstanding';
import ReportsSetBalanceLimit from '../pages/modules/master_distributor/ReportsSetBalanceLimit';
import ReportsOutstandingSummary from '../pages/modules/master_distributor/ReportsOutstandingSummary';
import ReportsDistributorTransactions from '../pages/modules/master_distributor/ReportsDistributorTransactions';
import ReportsRetailerTransactions from '../pages/modules/master_distributor/ReportsRetailerTransactions';
import MyProfile from '../pages/profile/MyProfile';

const MasterDistributorRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/dashboard" element={<MasterDistributorDashboard />} />
      <Route path="/user-management/retailer" element={<UserManagementRetailer />} />
      <Route path="/user-management/distributor" element={<UserManagementDistributor />} />
      <Route path="/top-up-request/from-retailer" element={<TopUpRequestFromRetailer />} />
      <Route path="/top-up-request/send" element={<SendTopUpRequest />} />
      <Route path="/reports/ledger" element={<ReportsLedger />} />
      <Route path="/reports/commission" element={<ReportsCommission />} />
      <Route path="/reports/top-up-history" element={<ReportsTopUpHistory />} />
      <Route path="/reports/distributor-transactions" element={<ReportsDistributorTransactions />} />
      <Route path="/reports/retailer-transactions" element={<ReportsRetailerTransactions />} />
      <Route path="/reports/outstanding-reports" element={<ReportsOutstanding />} />
      <Route path="/reports/set-balance-limit" element={<ReportsSetBalanceLimit />} />
      <Route path="/reports/outstanding" element={<ReportsOutstandingSummary />} />
      <Route path="/profile" element={<MyProfile />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
};

export default MasterDistributorRoutes;

